import * as moment from 'moment';
import {Moment} from "moment";

export const DATE_TIME_FORMAT:string = "DD.MM.YYYY HH:mm";

export const CALENDAR_MIN = new Date();
CALENDAR_MIN.setHours(8);
CALENDAR_MIN.setMinutes(0, 0, 0);

export const CALENDAR_MAX = new Date();
CALENDAR_MAX.setHours(17);
CALENDAR_MAX.setMinutes(0, 0, 0);

export default class DateUtils {

    public dateTimeStringToDate(date:string){
        if (!!date && date.indexOf("Date") > -1) {
            return date ? new Date(parseInt(date.substring(6, 19))) : null;
        } 

        return dateStringToMoment(date, DATE_TIME_FORMAT).toDate();
    }

    public dateToDateTimeString(date:Date){
        return `/Date(${date.getTime()})/`
    }
}

export const dateStringToMoment = (dateString : string | undefined, dateStringFormat:string = DATE_TIME_FORMAT) : Moment | null => {
    if (!dateString){
        return null;
    }

    // Check if the date string is in ISO 8601 format
    const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z?$/;
    if (iso8601Regex.test(dateString)) {
        return moment(dateString)
    }
    // Otherwise, assume it's in the provided format
    return moment(dateString, dateStringFormat);
};

export const isDateStringBeforeToday = (dateString : string | undefined, dateStringFormat:string = DATE_TIME_FORMAT): boolean => {

    if (!dateString){
        return false;
    }

    return moment(dateString, dateStringFormat) < moment().startOf("day");
};

// Conversion for dates on format "/Date(1580425200000)/" to Moment
export const sharePointDateStringToMoment = (sharePointDateString : any) : Moment => {
    if (!!sharePointDateString && sharePointDateString.indexOf("Date") > -1) {
        moment.unix((sharePointDateString.match(/\d+/)[0] as number) / 1000)
    } 

    // Check if the date string is in ISO 8601 format
    const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z?$/;
    if (iso8601Regex.test(sharePointDateString)) {
        return moment(sharePointDateString);
    }

    // Otherwise, assume it's in the provided format
    return moment(sharePointDateString, DATE_TIME_FORMAT);
}

